import React, {Component} from 'react';
import './Default.css'
import './Slider.css'
import objeler from '../objeler';
const SliderStyle = {
    width: '100%',
    height: '100%',
    margin:0,
    background:'red',
    boxSizing:'border-box',
    position:'absolute',
    webkitAppearance:'none'

};
class Slider extends Component {
    constructor(props) {
        super(props);
        const {JpgBlob} = this.props;
        const inputRef = React.createRef(null);
        this.imgOnLoad = this.imgOnLoad.bind(this)
        this.imgRef = React.createRef();
    };

    componentDidMount() {
    }

    imgOnLoad() {
        const height = this.imgRef.current.naturalHeight
        const width = this.imgRef.current.naturalWidth
        const ElementProps = objeler['ElementProps'];
        ElementProps.JpgOriginalWidth = width;
        ElementProps.JpgOriginalHeight = height;
        ElementProps.JpgOriginalAspectRatio = width / height;
        const {pictureOnLoad} = this.props;
        pictureOnLoad(ElementProps);
    }

    render() {
        const {file, content, type} = this.props;

        return (
            <React.Fragment>
                {type}
                <div id="tar" ref="tar">
                    <input type="range" min="1" max="100" value="50" className="slider" />
                </div>
            </React.Fragment>
        );
    }
}

export default Slider;